'use-client';
import * as React from 'react';
import type { CoBrandingBannerProps } from '../../../CoBrandingBannerDesktop.types';
import style from '../../styles/CoBrandingBannerDesktop.scss';
import CoBrandingBannerDesktop from '../../CoBrandingBannerDesktop';

const ClassicCoBrandingBannerDesktop: React.FC<
  CoBrandingBannerProps
> = props => {
  return <CoBrandingBannerDesktop {...props} style={style} />;
};

export default ClassicCoBrandingBannerDesktop;
